const createTextWithIconTokens = ({ colors, fontSizes, iconSizes }) => ({
  color: colors.neutrals[2],
  fontSize: fontSizes.body[1],
  iconSize: iconSizes.small,
});

export default createTextWithIconTokens;
